<!-- Premium Preloader -->
<div class="preloader premium-preloader">
    <div class="loader-content">
        <div class="logo-wrapper">
            <img src="../../../../assets/img/new_logo.png" class="img-fluid floating-logo" alt="FBIC Logo">
            <div class="glowing-ring"></div>
            <div class="glowing-ring-2"></div>
        </div>
        <h4 class="loading-text">KMSC<span>.</span><span>.</span><span>.</span></h4>
    </div>
</div>
<!-- End Preloader -->